"use strict";
/* eslint-disable no-dupe-keys */
module.exports = {
    settlement: 'Avräkning' || 'settlement',
    createForPeriod: 'Skräddarsy en avräkning' || 'createForPeriod',
    sendToSupplierOrganization: 'Skicka till leverantörsorganisation' || 'sendToSupplierOrganization',
    receiveInvoiceFromSupplierOrganization: 'Ta emot faktura' || 'receiveInvoiceFromSupplierOrganization',
    markInvoiceAsDone: 'Markera som avslutad' || 'markInvoiceAsDone',
    resendReport: 'Skicka mail igen' || 'resendReport',
    setReceiver: 'Sätt mottagare' || 'setReceiver',
    cancel: 'Makulera' || 'cancel',
    addToReport: 'Lägg till justeringsrad' || 'addToReport',
    removeFromReport: 'Ta bort från rapport' || 'removeFromReport',
    sendToExternalFortnox: 'Skicka till Fortnox' || 'sendToExternalFortnox',
    upsert: '' || 'upsert',
    upsertWhenEmpty: '' || 'upsertWhenEmpty',
    updateWhenEmpty: '' || 'updateWhenEmpty',
    update: '' || 'update',
    id: 'Identitet' || 'id',
    settlementNumber: 'Avräkning' || 'settlementNumber',
    settlementState: 'Status' || 'settlementState',
    settlementStates: {
        created: 'Skapad' || 'created',
        sentToSupplierOrganization: 'Skickad' || 'sentToSupplierOrganization',
        invoiceReceivedFromSupplierOrganization: 'Mottagen av Flaivy' || 'invoiceReceivedFromSupplierOrganization',
        invoiceCompleted: 'Bokförd' || 'invoiceCompleted',
    },
    cancelled: 'Makulerad' || 'cancelled',
    copackAgreement: 'Copack-avtal' || 'copackAgreement',
    orderBrokerageAgreement: 'Ordermäklaravtal' || 'orderBrokerageAgreement',
    owningSupplierOrganizationId: 'Levarantörsorganisation' || 'owningSupplierOrganizationId',
    invoiceId: 'Faktura' || 'invoiceId',
    startDate: 'Rapportens startdatum' || 'startDate',
    endDate: 'Rapportens slutdatum' || 'endDate',
    settlementOrderValue: 'avräkningens ordervärde' || 'settlementOrderValue',
    totalAlcoholTaxIncDiscount: 'Total alkoholskatt inklusive avdrag' || 'totalAlcoholTaxIncDiscount',
    totalAlcoholTax: 'Total alkoholskatt' || 'totalAlcoholTax',
    totalPostponedAlcoholTax: 'Total EMCS alkoholskatt' || 'totalPostponedAlcoholTax',
    totalInvoicedBySupplierOrganization: 'Belopp som leverantören har fakturerat' ||
        'totalInvoicedBySupplierOrganization',
    totalCommission: 'Total provision' || 'totalCommission',
    totalAdjustment: 'Total justering' || 'totalAdjustment',
    totalToBill: 'Belopp att fakturera' || 'totalToBill',
    serviceAgreement: 'Serviceavtal' || 'serviceAgreement',
    serviceAgreements: {
        'v2.5': 'v2.5 - minimum serviceavgift och taggade kunder - Använder order och reklamationer' ||
            'v2.5',
        v3: 'v3' || 'v3',
    },
    totalCost: 'Totalkostnad för leverantören över perioden' || 'totalCost',
    VATSummary: 'Moms' || 'VATSummary',
    receiverCompanyName: 'Mottagande företag' || 'receiverCompanyName',
    receiverAddress: 'Mottagarens adress' || 'receiverAddress',
    receiverZipCode: 'Mottagarens postnummer' || 'receiverZipCode',
    receiverCity: 'Mottagarens stad' || 'receiverCity',
    receiverOrganisationNumber: 'Mottagarans organisationsnummer' || 'receiverOrganisationNumber',
    settlementRows: {
        id: 'Identitet' || 'id',
        article: 'Artikel' || 'article',
        deliveredQuantity: 'Levererat antal' || 'deliveredQuantity',
        name: 'Produktnamn' || 'name',
        price: 'pris' || 'price',
        settlementOrderValue: 'ordervärde' || 'settlementOrderValue',
        discount: 'Rabatt' || 'discount',
        totalAlcoholTax: 'Total alkoholskatt' || 'totalAlcoholTax',
        totalPostponedAlcoholTax: 'Total EMCS alkoholskatt' || 'totalPostponedAlcoholTax',
        totalCommission: 'Total provision för varan' || 'totalCommission',
        commissionPercentage: 'Provisionsprocent' || 'commissionPercentage',
        section: 'Sektion' || 'section',
        sections: {
            sales: 'Försäljning' || 'sales',
            systembolaget: 'Försäljning till Systembolaget' || 'systembolaget',
            adjustments: 'Avgifter och justeringar' || 'adjustments',
        },
        rowDetails: 'Spårning' || 'rowDetails',
        isAdjustment: 'Justeringsrad' || 'isAdjustment',
    },
};
